<job-description-lca-work-library [primaryData]="primaryData"
[isForeignCompany]="isForeignCompany"></job-description-lca-work-library>
